<template>
<!-- 押金管理 -->
    <div class="deposit-control">
        <el-table
            border
            ref="tableData"
            :data='tableData'
            style="width: 100%"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange">
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="createdAt" :label="$t('Contract.charge_date')"></el-table-column>
            <el-table-column prop="storeName" :label="$t('Common.store')"></el-table-column>
            <el-table-column prop="clientName" :label="$t('Member.name2')">
                <template slot-scope="{row}">
                    <span
                        @click="handleUser(row.clientId)"
                        class="task-workers cursor-pointer">
                        {{ row.clientName }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="cardNum" :label="$t('Common.card_number')"></el-table-column>
            <el-table-column prop="clientPhone" :label="$t('Common.telephone_number')"></el-table-column>
            <el-table-column prop="lockerCode" :label="$t('Common.cabinet_number')"></el-table-column>
            <el-table-column prop="depositType" :label="$t('Sell.yajin_type')"></el-table-column>
            <el-table-column prop="depositStatus" :label="$t('Sell.yajin_status')"></el-table-column>
            <el-table-column prop="amt" :label="$t('Sell.yajin_money')"></el-table-column>
            <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler2')"></el-table-column>
            <el-table-column prop="receiverStaffNickname" :label="$t('Sell.Pay.people')"></el-table-column>
            <el-table-column prop="remark" :label="$t('Common.remark')"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
    </div>
</template>
<script>
import handleUser from '@/mixins/handleUser.js';

export default {
    name: 'depositControl',
    props: ['activeName', 'form', 'date'],
    mixins: [handleUser],
    data() {
        return {
            loading: false,
            contracts: [],
            tableData: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeName(val) {
            if (val === 'deposit') this.fetchData();
        },
    },
    created() {
        if (this.activeName === 'deposit') this.fetchData();
    },
    methods: {
        // 不传form仅刷新页面
        flush() {},
        // 根据form筛选
        fetchData(page = null) {
            let form = Object.assign({}, this.form);
            if (page) this.pagination.page = page;
            if (this.form.depositStatus) {
                form.depositStatusCode = this.form.depositStatus;
                delete form.depositStatus;
            }
            if (this.form.depositType) {
                form.depositTypeCode = this.form.depositType;
                delete form.depositType;
            }
            if (this.date && this.date.length) {
                form.createdAtStart = this.date[0];
                form.createdAtEnd = this.date[1];
            }
            this.loading = true;
            API.get('contract/deposit/pages', {
                params: form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}个记录`;
                this.$emit('input', msg);
            }).finally(() => this.loading = false);
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.tableData.toggleRowSelection(row);
                });
            } else {
                this.$refs.tableData.clearSelection();
            }
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.contracts = val;
            this.$emit('headListen', this.contracts);
        },
    },
};
</script>
<style lang="scss">
.task-workers {
    color: #409EFF;
}
.task-status{
    color: #2a9546;
}
</style>
